import React from 'react';
import BaseNav from '@shared/components/common/BaseNav';
import SyncHistoryList from '@shared/components/common/SyncHistoryList';
import FloatingNav from '@/components/common/FloatingNav';

export default function SyncHistoryPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <BaseNav />
      <div className="mt-14 flex-1 overflow-auto">
        <SyncHistoryList />
      </div>
      <FloatingNav />
    </div>
  );
}
